export const IMAGES = {
  onboardingDog: require('./onboardingDog.svg'),
  onboardingPrev: require('./onboardingPrev.svg'),
  onboardingClose: require('./onboardingClose.svg'),
  onboardingLastDog: require('./onboardingLastDog.svg'),
  delIcon: require('./closeIcon.svg') 
};
